import { Stack } from '@mui/material';
import formatDate from '../../../../components/common/formatDate';
import { useQuery } from '../../../../hooks/UseQuery';
import TagSelector from '../../storeSetup/common/Tags';

const TBody = ({ moduleData }: any) => {
  const part_name = useQuery('part_name');
  // const part_number = useQuery('part_number');
  return moduleData?.map((item: any, index: number) => (
    <tr>
      <td>{item?.date && formatDate(item?.date)}</td>
      <td>{item?.ri_part_id?.part_name || part_name}</td>
      <td>{item?.invoice_no || item?.job_card_no}</td>
      <td>{item?.mrr_no}</td>
      <td>{item?.opening_column}</td>
      <td>{item?.receipt_qty}</td>
      <td>{item?.issued_qty}</td>
      <td>{item?.balance_qty}</td>
      <td style={{ minWidth: '450px', maxWidth: '500px', textAlign: 'center' }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <TagSelector
            tags={item?.location?.length > 0 ? item?.location : null}
            populateField={'compartment_id'}
            fieldName1="name"
            fieldName2="qty"
          />
        </Stack>
      </td>
    </tr>
  ));
};

export default TBody;
